
const isAlexEnabled = () => {
    if (window.amplify_lantern_config) {
        return window.amplify_lantern_config.alyx_enabled === 'true';
    }
    return false;
};

export const getAvatarPosition = (positionConfig, isExtendedView = false) => {
    if (isAlexEnabled()) {
        return positionConfig.alyxPosition;
    }
    return isExtendedView
        ? positionConfig.extendedViewPosition
        : positionConfig.defaultViewPosition;
};

export const selectAvatarAudio = (defaultAudio, alyxAudio) => (isAlexEnabled() ? alyxAudio : defaultAudio);

export default isAlexEnabled;
